// Helper utility to capture console errors and warnings

// Initialize the errors array on the window object
window._errors = [];

// Capture console.error and console.warn output
export function captureConsole() {
  // Store original methods
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  // Override console.error
  console.error = function(...args) {
    // Push to our errors array
    window._errors.push({
      type: 'error',
      message: args.map(arg => 
        typeof arg === 'object' ? JSON.stringify(arg) : arg
      ).join(' '),
      timestamp: new Date().toISOString()
    });
    
    // Call original method
    originalConsoleError.apply(console, args);
  };

  // Override console.warn
  console.warn = function(...args) {
    // Push to our errors array
    window._errors.push({
      type: 'warning',
      message: args.map(arg => 
        typeof arg === 'object' ? JSON.stringify(arg) : arg
      ).join(' '),
      timestamp: new Date().toISOString()
    });
    
    // Call original method
    originalConsoleWarn.apply(console, args);
  };
}

// Helper to get the captured errors
export function getCapturedErrors() {
  return window._errors;
}

// Helper to clear captured errors
export function clearCapturedErrors() {
  window._errors = [];
  return [];
}
